import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import ProductDto from "../components/Common/dtos/ProductDto";

export type ProductUpsertDto = Omit<ProductDto, 'id' | 'sites'> & { siteIds?: string[] };

const path = (businessId: string) => `/api/businesses/${businessId}/products`;

const createSpec = (businessId: string): UserRequestSpec => ({
  path: path(businessId),
  method: HttpMethod.POST,
});

const updateSpec = (businessId: string, productId: string): UserRequestSpec => ({
  path: `${path(businessId)}/${productId}`,
  method: HttpMethod.PUT,
});

const useUpsertProduct = (productId?: string, options?: RequestOptions<string>) => {
  const business = useSelectedBusiness();

  var spec = productId
    ? updateSpec(business.id, productId)
    : createSpec(business.id);

  return useUserRequest<ProductUpsertDto, string>(spec, options);
}

export default useUpsertProduct;
